import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'

import vid1 from '../images/ovid (1).mp4'
import vid2 from '../images/ovid (2).mp4'
import vid3 from '../images/ovid (3).mp4'

import vid4 from '../images/Svid (1).mp4'
import vid5 from '../images/Svid (2).mp4'
import vid6 from '../images/Svid (3).mp4'


const Videos = () => {
  return (
    <div className="container py-5">
      
      <h2 className="text-center mb-4 fw-bold">
        Our Featured Videos
      </h2>

      <div className="row g-4">
        
        {/* Video 1 */}
        <div className="col-md-4">
          <div className="card shadow-lg border-0 h-100">
            <div className="card-body p-0 d-flex">
              <video 
                src={vid4} 
                className="w-100 rounded"
                controls 
                autoPlay 
                muted 
                loop
                style={{
                  height: '300px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        </div>

        {/* Video 2 */}
        <div className="col-md-4">
          <div className="card shadow-lg border-0 h-100">
            <div className="card-body p-0 d-flex">
              <video 
                src={vid5} 
                className="w-100 rounded"
                controls 
                autoPlay 
                muted 
                loop
                style={{
                  height: '300px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        </div>

        {/* Video 3 */}
        <div className="col-md-4">
          <div className="card shadow-lg border-0 h-100">
            <div className="card-body p-0 d-flex">
              <video 
                src={vid6} 
                className="w-100 rounded"
                controls 
                autoPlay 
                muted 
                loop
                style={{
                  height: '300px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        </div>

        {/* Video 4 */}
        <div className="col-md-4">
          <div className="card shadow-lg border-0 h-100">
            <div className="card-body p-0 d-flex">
              <video 
                src={vid1} 
                className="w-100 rounded"
                controls 
                autoPlay 
                muted 
                loop
                style={{
                  height: '300px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        </div>

        {/* Video 5 */}
        <div className="col-md-4">
          <div className="card shadow-lg border-0 h-100">
            <div className="card-body p-0 d-flex">
              <video 
                src={vid2} 
                className="w-100 rounded"
                controls 
                autoPlay 
                muted 
                loop
                style={{
                  height: '300px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        </div>

        {/* Video 6 */}
        <div className="col-md-4">
          <div className="card shadow-lg border-0 h-100">
            <div className="card-body p-0 d-flex">
              <video 
                src={vid3} 
                className="w-100 rounded"
                controls 
                autoPlay 
                muted 
                loop
                style={{
                  height: '300px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Videos


